import { useIsMobile } from '@/hooks/use-mobile';
import { StickyHeader } from './StickyHeader';
import { FiltersBlock } from './FiltersBlock';
import { MobileFiltersSheet } from './MobileFiltersSheet';

interface Community {
  id: string;
  name: string;
  members_count?: number;
}

interface CollapsibleFeedFiltersProps {
  postTypeFilter: string;
  onPostTypeFilterChange: (value: string) => void;
  selectedCommunity: string;
  onCommunityChange: (value: string) => void;
  locationFilter: string;
  onLocationFilterChange: (value: string) => void;
  communities: Community[];
  communitiesLoading: boolean;
  filteredCount: number;
  totalCount: number;
  showFilters: boolean;
  onToggleFilters: () => void;
  zoneFilters: {
    activeTab: 'climate' | 'hardiness';
    climateZone?: string;
    country?: string;
    hardinessZone?: string;
    showMyZoneOnly: boolean;
  };
  onZoneFiltersChange: (filters: any) => void;
}

interface ExtendedCollapsibleFeedFiltersProps extends CollapsibleFeedFiltersProps {
  isLiteMode?: boolean;
  selectedContentType?: 'posts' | 'casts' | 'my_teams';
  onContentTypeChange?: (type: 'posts' | 'casts' | 'my_teams') => void;
}

export const CollapsibleFeedFilters = ({
  postTypeFilter,
  onPostTypeFilterChange,
  selectedCommunity,
  onCommunityChange,
  locationFilter,
  onLocationFilterChange,
  communities,
  communitiesLoading,
  filteredCount,
  totalCount,
  showFilters,
  onToggleFilters,
  zoneFilters,
  onZoneFiltersChange,
  isLiteMode = false,
  selectedContentType = 'posts',
  onContentTypeChange
}: ExtendedCollapsibleFeedFiltersProps) => {
  const isMobile = useIsMobile();

  return (
    <>
      {/* Sticky header with mode badge, filter toggle, and content tabs */}
      <StickyHeader 
        filtersOpen={showFilters}
        onToggleFilters={onToggleFilters}
        isLiteMode={isLiteMode}
        selectedContentType={selectedContentType}
        onContentTypeChange={onContentTypeChange}
      />

      {/* Desktop: Collapsible filters block */}
      <div className="hidden md:block">
        <FiltersBlock 
          open={showFilters}
          postTypeFilter={postTypeFilter}
          onPostTypeFilterChange={onPostTypeFilterChange}
          selectedCommunity={selectedCommunity}
          onCommunityChange={onCommunityChange}
          locationFilter={locationFilter}
          onLocationFilterChange={onLocationFilterChange}
          filteredCount={filteredCount}
          totalCount={totalCount}
          zoneFilters={zoneFilters}
          onZoneFiltersChange={onZoneFiltersChange}
        />
      </div>

      {/* Mobile: Bottom sheet */}
      <div className="md:hidden">
        <MobileFiltersSheet 
          open={showFilters}
          onClose={onToggleFilters}
          postTypeFilter={postTypeFilter}
          onPostTypeFilterChange={onPostTypeFilterChange}
          selectedCommunity={selectedCommunity}
          onCommunityChange={onCommunityChange}
          locationFilter={locationFilter}
          onLocationFilterChange={onLocationFilterChange}
          filteredCount={filteredCount}
          totalCount={totalCount}
          zoneFilters={zoneFilters}
          onZoneFiltersChange={onZoneFiltersChange}
        />
      </div>
    </>
  );
};